import classNames from 'classnames'

import s from './Spinner.scss'

const Spinner = ({ style = {}, className = '' }) => (
  <span className={classNames(s.spinner, className)} style={style} />
)

export default Spinner
